/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState, useCallback, useEffect } from 'react';

import ReactSelect from 'react-select/creatable';

import { FiAlertCircle } from 'react-icons/fi';
import { Container } from './styles';
import { Error } from '../styles';
import { useLanguage } from 'src/hooks/Language';
import { useForm } from 'src/components/UIComponents/Form/provider/formProvider';

interface IOptions {
  text?: string;
  label?: string;
  value: string | number;
}

interface Props {
  name: string;
  label: string;
  setCallback?: Function;
  options: Array<IOptions>,
  isMulti?: boolean;
  defaultV?: string;
  mandatory?: boolean;
  index?: number;
}


const SelectSimple: React.FC<Props> = ({
  name,
  label,
  options,
  mandatory = false,
  defaultV = "",
  isMulti = false,
  index = 100,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCallback = (value) => { },
  ...rest
}) => {
  const selectRef = useRef(null);



  const [isFocus, setIsFocus] = useState(false);

  const [value, setValue] = useState<any>('');
  const { translate } = useLanguage();
  const handleInputBlur = useCallback(() => {
    setIsFocus(false);
  }, []);





  const { registerField } = useForm();
  const setValueData = (content) => {

    setValue(content)
  }

  const getValue = () => {

    return value;
  }

  useEffect(() => {
    registerField(
      name,
      setValueData,
      getValue
    );
  }, [name, value]);



  //* * Usefull function to call external functions */
  useEffect(() => {
    if (value) {
      setCallback(value);
    }
  }, [value, setCallback]);


  const activeCallback = () => {
    if (value) {
      setCallback(value);
    }

  }
  const currentValue = options.find(i => i?.value === value)
  return (
    <Container isFocused={isFocus} style={{ zIndex: index ? (100 - index) : 100 }}>
         <label style={{ color: '#333', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{translate( label)}{mandatory ? <p style={{ display: 'inline-block', color: 'rgb(150,0,0)', fontSize: '11px', marginLeft: '15px', marginRight: '32px' }}>*{translate('Obrigatório')}</p> : <></>}</label>
    
<div className='full-width column-start'>

      <ReactSelect

        onBlur={handleInputBlur}
        options={options}
        onChange={selectedValue => {
          setValue(selectedValue?.value);

          activeCallback();
        }}
        value={currentValue}
        ref={selectRef}
        classNamePrefix="react-select"
        {...rest}
      />
</div>
    </Container>
  );
};
export default SelectSimple;
